<template>
  <div class="card shadow-sm text-dark text-start">
    <div class="card-header fs-6 fw-bold">Introduction and Instructions</div>
    <div class="card-body p-2">
      Proceed through this self-assessment tool, competency by competency,
      selecting the responses that best describe your knowledge and skills
      today.
      <div class="d-flex justify-content-center">
        <div class="mt-3">
          <button class="btn osu-button btn-dark" @click="startSurvey">
            Get Started
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "CurrentContainerView",
  components: {},
  data() {
    return {};
  },
  props: {},
  computed: {
    ...mapGetters(["getQuestionData"])
  },
  methods: {
    ...mapActions(["setCurrentQuestion"]),
    startSurvey() {
      let firstQuestion;
      this.getQuestionData.forEach((question) => {
        if (question.index == 0) {
          firstQuestion = { ...question };
        }
      });
      this.setCurrentQuestion(firstQuestion);
    }
  }
};
</script>

<style scoped></style>
